/**
 * Reads the guest wishlist from localStorage and keeps the header count badge in sync.
 *
 * THEME_NATIVE, device-local only — there is no account sync in this phase. The wishlist
 * page/product-page controls that write to `STORAGE_KEY` are built in a later phase; this
 * script only owns the header badge and the `wishlist:updated` contract those controls should
 * dispatch after changing storage, so the badge updates without a full page reload.
 */
const STORAGE_KEY = 'bh:wishlist';

/** @returns {string[]} */
function getWishlist() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function updateWishlistBadges() {
  const count = getWishlist().length;

  document.querySelectorAll('[data-wishlist-count]').forEach((element) => {
    element.textContent = count > 0 ? String(count) : '';
    element.hidden = count === 0;
  });
}

document.addEventListener('DOMContentLoaded', updateWishlistBadges);
document.addEventListener('wishlist:updated', updateWishlistBadges);
window.addEventListener('pageshow', updateWishlistBadges);
window.addEventListener('storage', (event) => {
  if (event.key === STORAGE_KEY) updateWishlistBadges();
});

if (document.readyState !== 'loading') updateWishlistBadges();
